import { customFetch } from '../composables/useCustomFetch';

export async function getUserData(options = {}) {
  return await customFetch('/api/user', 'get', options);
}

export async function postAddProgramById(id, options = {}) {
  return await customFetch(`/api/user/program/${id}`, 'post', options);
}

export async function deleteProgramById(id, options = {}) {
  return await customFetch(`/api/user/program/${id}`, 'delete', options);
}

export async function postAcceptTos(isInMailList, options = {}) {
  return await customFetch('/api/user/accept-tos', 'post', { body: { isInMailList }, ...options });
}

export async function getFileStorageToken(options = {}) {
  return await customFetch('/api/user/filestorage-token', 'get', options);
}
